// extracted by mini-css-extract-plugin
module.exports = {"faDetailAddressClass":"DetailsPage_faDetailAddressClass__oLiPU","faDetailsBuildingIcon":"DetailsPage_faDetailsBuildingIcon__2C86N"};